
<div class="w-full flex flex-row justify-center pt-12 1012-bp:pt-28 font-rubik">
  <div class="w-full max-w-1012 mx-5">
    <h1 class="about-us-text-h1">About Us</h1>
    <section class="text-black" v-html="getRichTextContent"></section>
  </div>
</div>
